import { useFirestoreQueryData } from "@react-query-firebase/firestore";
import { WorkspaceAccess } from "../models";
import { useCache } from "../context/CacheContext";
import { queryKeys } from "../data/queryKeys";

export const useUserWorkspaces = (email: string) => {
  const { cacheKey } = useCache();
  return useFirestoreQueryData(
    queryKeys.userWorkspaces(cacheKey, email),
    WorkspaceAccess.getUserWorkspaces(email),
    {
      subscribe: false,
    },
    {
      enabled: !!email,
    }
  );
};
